var map = {
	"./AllResources": [
		4573,
		6664,
		2163
	],
	"./AllResources.vue": [
		4573,
		6664,
		2163
	],
	"./BackButton": [
		3285,
		3285
	],
	"./BackButton.vue": [
		3285,
		3285
	],
	"./ButtonFullScreen": [
		3061,
		3061
	],
	"./ButtonFullScreen.vue": [
		3061,
		3061
	],
	"./Card": [
		3553,
		3553
	],
	"./Card.vue": [
		3553,
		3553
	],
	"./Card/CardDefault": [
		118,
		118
	],
	"./Card/CardDefault.vue": [
		118,
		118
	],
	"./Card/CardSynopsis": [
		548,
		548
	],
	"./Card/CardSynopsis.vue": [
		548,
		548
	],
	"./ChildUnit": [
		1654,
		1654
	],
	"./ChildUnit.vue": [
		1654,
		1654
	],
	"./ConceptBoxFull": [
		7963,
		7963
	],
	"./ConceptBoxFull.vue": [
		7963,
		7963
	],
	"./ConceptBoxSimple": [
		4316,
		4316
	],
	"./ConceptBoxSimple.vue": [
		4316,
		4316
	],
	"./ConceptFilter": [
		4590,
		4590
	],
	"./ConceptFilter.vue": [
		4590,
		4590
	],
	"./ConceptFilterDropdown": [
		4665,
		4665
	],
	"./ConceptFilterDropdown.vue": [
		4665,
		4665
	],
	"./ConceptModal": [
		159,
		9111,
		159
	],
	"./ConceptModal.vue": [
		159,
		9111,
		159
	],
	"./ConcretesMenu": [
		9232,
		9232
	],
	"./ConcretesMenu.vue": [
		9232,
		9232
	],
	"./DBokMenu": [
		5916,
		5916
	],
	"./DBokMenu.vue": [
		5916,
		5916
	],
	"./Duration": [
		3262,
		3262
	],
	"./Duration.vue": [
		3262,
		3262
	],
	"./ElementNav": [
		3789,
		3789
	],
	"./ElementNav.vue": [
		3789,
		3789
	],
	"./ExercisesList": [
		8673,
		9111,
		8355
	],
	"./ExercisesList.vue": [
		8673,
		9111,
		8355
	],
	"./ExercisesNavigation": [
		2358,
		2358
	],
	"./ExercisesNavigation.vue": [
		2358,
		2358
	],
	"./FakeCheckbox": [
		1087,
		1087
	],
	"./FakeCheckbox.vue": [
		1087,
		1087
	],
	"./Footer": [
		7866
	],
	"./Footer.vue": [
		7866
	],
	"./Goals": [
		6218,
		6218
	],
	"./Goals.vue": [
		6218,
		6218
	],
	"./GoalsModal": [
		3165,
		9111,
		3165
	],
	"./GoalsModal.vue": [
		3165,
		9111,
		3165
	],
	"./GoalsWrapper": [
		6904,
		6904
	],
	"./GoalsWrapper.vue": [
		6904,
		6904
	],
	"./LEPagesNav": [
		2935,
		2935
	],
	"./LEPagesNav.vue": [
		2935,
		2935
	],
	"./LETopbarDefault": [
		5747,
		52,
		2674
	],
	"./LETopbarDefault.vue": [
		5747,
		52,
		2674
	],
	"./LETopbarPuls": [
		9495,
		9495
	],
	"./LETopbarPuls.vue": [
		9495,
		9495
	],
	"./LanguageAndTheme": [
		3606,
		3606
	],
	"./LanguageAndTheme.vue": [
		3606,
		3606
	],
	"./LanguageSelect": [
		52,
		52,
		1810
	],
	"./LanguageSelect.vue": [
		52,
		52,
		1810
	],
	"./LearningElements/Activity": [
		4926,
		4926
	],
	"./LearningElements/Activity.vue": [
		4926,
		4926
	],
	"./LearningElements/Article": [
		1028,
		1028
	],
	"./LearningElements/Article.vue": [
		1028,
		1028
	],
	"./LearningElements/Audio": [
		80,
		6213,
		6266
	],
	"./LearningElements/Audio.vue": [
		80,
		6213,
		6266
	],
	"./LearningElements/ClickableArea": [
		3276,
		3276
	],
	"./LearningElements/ClickableArea.vue": [
		3276,
		3276
	],
	"./LearningElements/ContentCarousel": [
		4146,
		6213,
		5359
	],
	"./LearningElements/ContentCarousel.vue": [
		4146,
		6213,
		5359
	],
	"./LearningElements/EmbedExercise": [
		3052,
		3052
	],
	"./LearningElements/EmbedExercise.vue": [
		3052,
		3052
	],
	"./LearningElements/H5P": [
		6304,
		6304
	],
	"./LearningElements/H5P.vue": [
		6304,
		6304
	],
	"./LearningElements/ImageElement": [
		9392,
		9392
	],
	"./LearningElements/ImageElement.vue": [
		9392,
		9392
	],
	"./LearningElements/LtiElement": [
		5967,
		5967
	],
	"./LearningElements/LtiElement.vue": [
		5967,
		5967
	],
	"./LearningElements/SectionEndTagElement": [
		3381,
		3381
	],
	"./LearningElements/SectionEndTagElement.vue": [
		3381,
		3381
	],
	"./LearningElements/SectionTagElement": [
		9779,
		9779
	],
	"./LearningElements/SectionTagElement.vue": [
		9779,
		9779
	],
	"./LearningElements/TextBox": [
		4637,
		4637
	],
	"./LearningElements/TextBox.vue": [
		4637,
		4637
	],
	"./LearningElements/TextElement": [
		1756,
		1756
	],
	"./LearningElements/TextElement.vue": [
		1756,
		1756
	],
	"./LearningElements/Video": [
		2510,
		2510
	],
	"./LearningElements/Video.vue": [
		2510,
		2510
	],
	"./LessonAccordeon": [
		972,
		972
	],
	"./LessonAccordeon.vue": [
		972,
		972
	],
	"./LessonHeader": [
		368,
		368
	],
	"./LessonHeader.vue": [
		368,
		368
	],
	"./LessonSection": [
		5464,
		5464
	],
	"./LessonSection.vue": [
		5464,
		5464
	],
	"./LessonSectionPrimary": [
		5911,
		5911
	],
	"./LessonSectionPrimary.vue": [
		5911,
		5911
	],
	"./LessonToolbar": [
		9707,
		9707
	],
	"./LessonToolbar.vue": [
		9707,
		9707
	],
	"./LessonsMenu": [
		2477,
		2477
	],
	"./LessonsMenu.vue": [
		2477,
		2477
	],
	"./Level": [
		3234,
		3234
	],
	"./Level.vue": [
		3234,
		3234
	],
	"./LevelSelect": [
		8273,
		8273
	],
	"./LevelSelect.vue": [
		8273,
		8273
	],
	"./MenuLangSwitch": [
		5626,
		5626
	],
	"./MenuLangSwitch.vue": [
		5626,
		5626
	],
	"./MiniCard": [
		6199,
		6199
	],
	"./MiniCard.vue": [
		6199,
		6199
	],
	"./Nav": [
		6035,
		6035
	],
	"./Nav.vue": [
		6035,
		6035
	],
	"./Nav/NavBygg": [
		4394,
		4394
	],
	"./Nav/NavBygg.vue": [
		4394,
		4394
	],
	"./Nav/NavDefault": [
		2945,
		2945
	],
	"./Nav/NavDefault.vue": [
		2945,
		2945
	],
	"./Nav/NavLanding": [
		2970,
		2970
	],
	"./Nav/NavLanding.vue": [
		2970,
		2970
	],
	"./Nav/NavPrimary": [
		6013,
		6013
	],
	"./Nav/NavPrimary.vue": [
		6013,
		6013
	],
	"./Nav/NavPuls": [
		4385,
		4385
	],
	"./Nav/NavPuls.vue": [
		4385,
		4385
	],
	"./Nav/NavSynopsis": [
		426,
		426
	],
	"./Nav/NavSynopsis.vue": [
		426,
		426
	],
	"./Nav/NavVolum": [
		9833,
		9833
	],
	"./Nav/NavVolum.vue": [
		9833,
		9833
	],
	"./Note": [
		1235,
		4695
	],
	"./Note.vue": [
		1235,
		4695
	],
	"./OverlayInactive": [
		4653,
		4653
	],
	"./OverlayInactive.vue": [
		4653,
		4653
	],
	"./ResourceListItem": [
		6755,
		6755
	],
	"./ResourceListItem.vue": [
		6755,
		6755
	],
	"./ResourcesSection": [
		3565,
		3565
	],
	"./ResourcesSection.vue": [
		3565,
		3565
	],
	"./Searchbox": [
		3605,
		3605
	],
	"./Searchbox.vue": [
		3605,
		3605
	],
	"./SingleLesson": [
		7699,
		1236
	],
	"./SingleLesson.vue": [
		7699,
		1236
	],
	"./SwitchRole": [
		1366
	],
	"./SwitchRole.vue": [
		1366
	],
	"./Tags": [
		270,
		270
	],
	"./Tags.vue": [
		270,
		270
	],
	"./TeacherUnitTile": [
		6608,
		6608
	],
	"./TeacherUnitTile.vue": [
		6608,
		6608
	],
	"./TopBar/TopBarDefault": [
		9538,
		52,
		9688
	],
	"./TopBar/TopBarDefault.vue": [
		9538,
		52,
		9688
	],
	"./TopBar/TopBarVocational": [
		7980,
		52,
		9154
	],
	"./TopBar/TopBarVocational.vue": [
		7980,
		52,
		9154
	],
	"./Topbar": [
		7679
	],
	"./Topbar.vue": [
		7679
	],
	"./UnitHeader": [
		6446,
		6446
	],
	"./UnitHeader.vue": [
		6446,
		6446
	],
	"./UnitHeaderPrimary": [
		7349,
		9111,
		7349
	],
	"./UnitHeaderPrimary.vue": [
		7349,
		9111,
		7349
	],
	"./UnitOverview": [
		4846,
		5464,
		4846
	],
	"./UnitOverview.vue": [
		4846,
		5464,
		4846
	],
	"./UnitTabs": [
		875,
		5464,
		6664,
		9171
	],
	"./UnitTabs.vue": [
		875,
		5464,
		6664,
		9171
	],
	"./UnitTile": [
		3377,
		3377
	],
	"./UnitTile.vue": [
		3377,
		3377
	],
	"./User": [
		3912,
		3912
	],
	"./User.vue": [
		3912,
		3912
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 1413;
module.exports = webpackAsyncContext;